/**
 * @generated SignedSource<<23c6d870b5f2d5b87e71a23c4c6fc59b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardFiltersQuery$variables = Record<PropertyKey, never>;
export type DashboardFiltersQuery$data = {
  readonly allGradeLevels: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
  }>;
  readonly classes: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly section: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type DashboardFiltersQuery = {
  response: DashboardFiltersQuery$data;
  variables: DashboardFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GradeLevelNode",
    "kind": "LinkedField",
    "name": "allGradeLevels",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "classesFilterInput",
        "value": {
          "isActive": "ACTIVE",
          "siteIsActive": "ACTIVE"
        }
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "ClassNodeConnection",
    "kind": "LinkedField",
    "name": "classes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClassNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "section",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "classes(classesFilterInput:{\"isActive\":\"ACTIVE\",\"siteIsActive\":\"ACTIVE\"},first:100)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardFiltersQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardFiltersQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2e48ecff4ef229f726c657b66c57247c",
    "id": null,
    "metadata": {},
    "name": "DashboardFiltersQuery",
    "operationKind": "query",
    "text": "query DashboardFiltersQuery {\n  allGradeLevels {\n    id\n    name\n  }\n  classes(first: 100, classesFilterInput: {isActive: ACTIVE, siteIsActive: ACTIVE}) {\n    nodes {\n      id\n      name\n      section\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3cc49862e915249c2cb286cd9610974";

export default node;
